import React from 'react';
import { Box, Container, Typography, IconButton, useTheme } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import { FaTiktok, FaSpotify, FaApple } from 'react-icons/fa';

const Footer = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        backgroundColor: '#000000',
        py: 4,
        borderTop: `2px solid ${theme.palette.primary.main}`,
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center' }}>
          {/* Social Icons */}
          <Box sx={{ mb: 2 }}>
            <IconButton
              href="https://www.instagram.com/boxroosterband/?hl=en"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: '#FFFFFF',
                mx: 1,
                '&:hover': {
                  color: theme.palette.primary.light,
                  transform: 'scale(1.2)',
                },
                transition: 'all 0.3s',
              }}
            >
              <InstagramIcon fontSize="large" />
            </IconButton>
            <IconButton
              href="https://vm.tiktok.com/ZTRVotr7G/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: '#FFFFFF',
                mx: 1,
                '&:hover': {
                  color: theme.palette.primary.light,
                  transform: 'scale(1.2)',
                },
                transition: 'all 0.3s',
              }}
            >
              <FaTiktok size={28} />
            </IconButton>
            <IconButton
              href="https://open.spotify.com/artist/4MyemXDuB1bsOb4MO3lze3"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: '#FFFFFF',
                mx: 1,
                '&:hover': {
                  color: theme.palette.primary.light,
                  transform: 'scale(1.2)',
                },
                transition: 'all 0.3s',
              }}
            >
              <FaSpotify size={28} />
            </IconButton>
            <IconButton
              href="https://music.apple.com/us/artist/boxrooster/1793755446"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: '#FFFFFF',
                mx: 1,
                '&:hover': {
                  color: theme.palette.primary.light,
                  transform: 'scale(1.2)',
                },
                transition: 'all 0.3s',
              }}
            >
              <FaApple size={30} />
            </IconButton>
          </Box>

          {/* Copyright */}
          <Typography sx={{ color: '#888', fontSize: '0.9rem' }}>
            © {new Date().getFullYear()} BOXROOSTER. All Rights Reserved.
          </Typography>
          <Typography sx={{ color: '#555', fontSize: '0.8rem', mt: 1 }}>
            Long Island, New York
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
